// @ts-ignore

export const copy = <T>(data: T) => {
  return JSON.parse(JSON.stringify(data)) as T;
};

export const addLeadingZero = (num: number | string) => {
  return ("0" + num).slice(-2);
};

export const qSet = (
  name: string,
  value: string | number | undefined | null,
  q: any,
): any => {
  const query = copy(q);
  if (name && value) query[name] = value;
  if (!value && query[name]) {
    delete query[name];
  }
  return Object.keys(query).length > 0 ? query : {};
};

export function debounce(f: any, ms: number): any {
  let timer: NodeJS.Timeout | null = null;
  return (...args: any[]) => {
    const onComplete = () => {
      f.apply(null, args);
      timer = null;
    };
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(onComplete, ms);
  };
}

export function declension(n: number, titles: string[]) {
  /* функция склонения числительных
   * аргументы: n - само числительное, titles - массив существительных в форме ([предмет, предмета, предметов]) */
  return titles[
    n % 10 === 1 && n % 100 !== 11
      ? 0
      : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
      ? 1
      : 2
  ];
}

export function calcMarginPrice(
  price: number,
  margin: number,
  rounding: number,
) {
  if (rounding) {
    return (
      Math.ceil((Number(price) * (1 + margin / 100)) / rounding) * rounding
    );
  }
  return Number(price) * (1 + margin / 100);
}
